import { useBrand } from '../brand';
import { useChat } from '../chat/ChatLauncher';
import { TIPPA_PROMPTS } from '../chat/TippaCards';
import { useTrack } from '../track';

/**
 * A slim banner at the top of the signed-in home page pointing members at the chat's
 * multi and quaddie prompts. Each button opens the chat and asks straight away.
 * Shown only to members who may ask (the chat is on and they subscribe).
 */
export function AskBanner() {
  const chat = useChat();
  const brand = useBrand();
  const track = useTrack();
  const ask = chat?.ask;
  if (!ask) return null;
  const title = brand.chat?.title ?? 'Chat with us';
  return (
    <section className="ui-askb" aria-label="Ask for a multi or a quaddie">
      <span className="ic" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8a2.5 2.5 0 0 1-2.5 2.5H10l-4.2 3.6c-.5.4-1.3.1-1.3-.6V16A2.5 2.5 0 0 1 4 13.5z" />
        </svg>
      </span>
      <p className="tx">
        <b>{title}:</b> get a multi built at your price on the latest odds, or one of today&apos;s quaddies.
      </p>
      <span className="b">
        {TIPPA_PROMPTS.map((p) => (
          <button
            type="button"
            key={p.label}
            onClick={() => {
              track('ui_click', { target: 'ask_banner', topic: p.request.topic });
              ask(p.request);
            }}
          >
            {p.label}
          </button>
        ))}
      </span>
    </section>
  );
}
